import React, {  useState,useEffect, useTransition } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import he from 'he'
import Skeleton from '../../pages/skelton';

const DevotionalInformationCards = ({homeTithiData,homeTithiDataError,mmtImpDateData,mmtImpDateDataError}) => {
             
         const ssrTithiData = homeTithiData ? homeTithiData : null  
         const ssrImpDataOne = mmtImpDateData ? (mmtImpDateData.home_mmt_imp?.[0]?.home_mmt?.[0]) : null
         const ssrImpDataTwo = mmtImpDateData ? (mmtImpDateData.home_mmt_imp?.[0]?.home_imp_date?.[0]) : null
       
         
  
        const [tithiData,setTithiData]=useState(ssrTithiData)
        const [impDataOne,setImpOneData]=useState(ssrImpDataOne)
        const [impDataTwo,setImpDataTwo]=useState(ssrImpDataTwo)
        const [error,setError]=useState(null)
        const [loading,setLoading]=useState(false)
        const [currentDate] = useState(() => new Date());

        // const currentDate = new Date();
        const year = currentDate.getFullYear();
        const monthIndex = currentDate.getMonth();
         const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = months[monthIndex]; 

        const navigate = useNavigate()
       
          


    useEffect(() =>   {
      const hasSSRData =
    ssrTithiData &&
    ssrImpDataOne &&
    ssrImpDataTwo;
   
     if (hasSSRData) {
        
         setLoading(false)
         setError(null)
         return
     }
      
    
    else {
      setLoading(true)

      const getData =async () => {
      try {
              
        const impResp=await fetch('https://www.teluguone.com/devotional_api/devotionalHomeMmtImpSplitJson')
        const tithiResp = await fetch('https://www.teluguone.com/devotional_api/devotionalHomeTithiJson')
              if (!tithiResp.ok || !impResp.ok) throw new Error('Network response was not ok');

              const tithi=await tithiResp.json()
              const imp =await impResp.json()
              
            

                  setTithiData(tithi?.home_tithi ? tithi.home_tithi[0] : {})
                  setImpOneData(imp?.home_mmt_imp?.[0]?.home_mmt ? imp.home_mmt_imp[0].home_mmt[0] : {})
                  setImpDataTwo(imp?.home_mmt_imp?.[0]?.home_imp_date  ?  imp.home_mmt_imp[0].home_imp_date[0] : {})
                  setLoading(false)
                  setError(null)
                  
            
              
          }
          
          catch (error) {
            setTithiData(null)
            setImpOneData(null)
            setImpDataTwo(null) 
            setLoading(false) 
             setError(error.message)
             console.log(`Error : ${error.message}`)
              
          }

      }
           
         getData()    
    }

         
    },[])

  if (loading) {
    return (
        
        <div className='container-fluid'>
           <div className='row'>
             { Array(3).fill("o").map((_,index) =>
             
              <div className='col-12 col-sm-4' key={index}>
               <div className='devotional-information-card'>
                     <Skeleton type="square" />
                     <Skeleton type="paragraph" />
                     <Skeleton type="paragraph" />
                     <Skeleton type="paragraph" />
                     <Skeleton type="paragraph" />
               </div>
               </div>  
             ) }
           </div>
        </div>
    )
  }

  if (error) {

     return (
      <div className='container-fluid'>
           <div className='row'>
           <div className='col-12'>
                <div className="json-loading-error-div">
                   <img  src="/devotional/assets/images/json_error.png" alt="json_error" />
                </div>
           </div>
          </div>
      </div>
     )
  }


  return (
  
     
          <div className='row g-0'>
                 <div className='col-12 col-md-4 col-sm-6'>
                   { tithiData && <div className='devotional-information-card'>
                             <Link to="/tithi.html" className='devotional-home-common-title clickable'>Tithi - {tithiData.cdate ? tithiData.cdate  : 'Date'}</Link>
                             <p>{tithiData.tithi_title ? tithiData.tithi_title : "Tithi_Title"}</p>
                             <p><span className="text-danger">తిథి</span>	: {tithiData.tithi ? tithiData.tithi : "Tithi"}	</p>
                             <p><span className="text-danger">నక్షత్రం</span>	:	{tithiData.nakshatram ? tithiData.nakshatram : "Tithi"}	</p>
                             <p><span className="text-danger">వర్జ్యం</span>	:	{tithiData.varjyam ? tithiData.varjyam : "Tithi"}</p>
                             <p><span className="text-danger">దుర్ముహూర్తం</span>	:	{tithiData.durmuhurtam ? tithiData.durmuhurtam : "Tithi"}	</p>
                             <p><span className="text-danger">రాహుకాలం</span>	:	{tithiData.rahukalam ? tithiData.rahukalam : "Tithi"}	</p>
                   </div>}
                   </div>
                   {/*========================================================*/}

                   <div className='col-12 col-md-4 col-sm-6'>
                       {impDataOne && <div className='devotional-information-card'>
                             <Link to="/subpages/goodwordoftheday-668.html"  className='devotional-home-common-title clickable'>Oka Manchi Maata</Link>
                           
                             <div className='manchi-mata-div' dangerouslySetInnerHTML={{__html : impDataOne.manchi_mata ? he.decode(impDataOne.manchi_mata) : ''}}
                             
                             
                              onClick={() => navigate(impDataOne.manchi_url ? impDataOne.manchi_url.substring(impDataOne.manchi_url.indexOf('/devotional')+11) : '/subpages/goodwordoftheday-668.html' )}  />
                                   
                             
                           
                        </div>  }     
                   </div>
 
                 {/*========================================================*/}

                   <div className='col-12 col-sm-4 d-md-block d-none'>
                        {impDataTwo && <div className='devotional-information-card imp'>
                           <h6 className='devotional-home-common-title'> {month ? month : ''}, {year ? year : ''}  Important Days</h6>
                           {/* <div dangerouslySetInnerHTML={{__html : impDataTwo.imp_dates ?  he.decode(impDataTwo.imp_dates) : "No Data"}} className='dic-child' ></div> */}
                             <div dangerouslySetInnerHTML={{__html : impDataTwo.imp_dates_left ?  he.decode(impDataTwo.imp_dates_left) : "No Data"}} className='dic-child'></div>
                           <div dangerouslySetInnerHTML={{__html : impDataTwo.imp_dates_right ?  he.decode(impDataTwo.imp_dates_right) : "No Data"}} className='dic-child'></div>
                         </div>  }  
                   </div>
         </div>
    
  )
}

export default DevotionalInformationCards;
